import { style } from '@vanilla-extract/css';

export const documentContainer = style({});
